import React, { useEffect, useState } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { getDatabase, ref, get, onValue } from "firebase/database";
import { HashRouter, Routes, Route } from "react-router-dom";
import { auth } from "./firebase";

import Login from "./Login";
import Dashboard from "./Dashboard";
import DistributorDashboard from "./DistributorDashboard";
import OrdersPage from "./OrdersPage";
import OrderDetailPage from "./OrderDetailPage";
import DistributorLayout from "./DistributorLayout";
import BrandsPage from "./BrandsPage";
import CategoriesPage from "./CategoriesPage";
import VendeursPage from "./VendeursPage";
import AddVendeursPage from "./AddVendeurPage";
import EditVendeurPage from "./EditVendeurPage";
import ClientsListPage from "./ClientsListPage";
import AddClientPage from "./AddClientPage";
import EditClientPage from "./EditClientPage";
import ProductsPage from "./ProductsPage";
import EditProductPage from "./EditProductPage"; 
import AddProductPage from "./AddProductPage";
import LowStockProducts from "./DistributorLowStockProducts";
import UsersDashboard from "./UsersDashboard"; // الصفحة الرئيسية
import UserTypePage from "./UserTypePage"; // صفحة كل نوع
import UserDetailsPage from "./UserDetailsPage"; // صفحة تفاصيل مستخدم
import AllUsersPage from "./AllUsersPage";
import ClientOrdersPage from "./ClientOrdersPage";
import SoldProductsPage from "./SoldProductsPage";
import PrintReport from "./PrintReport";
import OrderPrintPage from "./OrderPrintPage";
import TicketPrintPage from "./TicketPrintPage";
import NotificationSender from "./NotificationSender";


function App() {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);
  const [userType, setUserType] = useState(null);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (u) => {
      if (u) {
        setUser(u);

        if (u.email === "admin@komondi.com") {
          setUserType("admin");
          setChecking(false);
          return;
        }

        try {
          const db = getDatabase();
          const snap = await get(ref(db, `users/${u.uid}/userType`));
          setUserType(snap.exists() ? snap.val() : "unknown");
        } catch {
          setUserType("unknown");
        }
      } else {
        setUser(null);
        setUserType(null);
      }
      setChecking(false);
    });

    return () => unsub();
  }, []);

  // مراقبة active
  useEffect(() => {
    if (!user) return;

    const db = getDatabase();
    const activeRef = ref(db, `users/${user.uid}/active`);

    const unsub = onValue(activeRef, (snapshot) => {
      if (snapshot.exists() && snapshot.val() === false) {
        alert(
          "Votre compte a été désactivé.\nPour plus d'informations, veuillez contacter notre support."
        );
        signOut(auth).then(() => window.location.reload());
      }
    });

    return () => unsub();
  }, [user]);

  if (checking) return <div style={{ padding: 30 }}>Loading...</div>;
  if (!user) return <Login />;
return (
  <HashRouter>
    <Routes>

      {/* ADMIN */}
       {userType === "admin" && (
          <>
            {/* Dashboard الرئيسي */}
            <Route path="/" element={<Dashboard />} />
            
            {/* المسارات الجديدة لصفحات المستخدمين */}
            <Route path="/users-dashboard" element={<UsersDashboard />} />
            <Route path="/users/:type" element={<UserTypePage />} />
            <Route path="/user/:userId" element={<UserDetailsPage />} />
            <Route path="/users/all" element={<AllUsersPage />} />

             <Route path="/admin/add-product/:uid" element={<AddProductPage />} />

             <Route path="/send-notification/:userId" element={<NotificationSender />} />
            {/* باقي المسارات كما هي */}
            <Route path="/*" element={<Dashboard />} />
          </>
        )}

    {/* PROFESSIONAL */}
{userType === "professional" && (
  <>
    {/* ✅ routes الطباعة خارج layout (وفوقه) */}
    <Route path="/print-report" element={<PrintReport />} />
    <Route path="/print-order/:distributorId/:orderId" element={<OrderPrintPage />} />
    <Route path="/print-ticket/:distributorId/:orderId" element={<TicketPrintPage />} />

    {/* ✅ layout */}
    <Route path="/*" element={<DistributorLayout />}>
      <Route index element={<DistributorDashboard uid={user.uid} />} />
      <Route path="products" element={<ProductsPage uid={user.uid} />} />
      <Route path="products/add" element={<AddProductPage uid={user.uid} />} />
      <Route path="products/categories" element={<CategoriesPage uid={user.uid} />} />
      <Route path="products/brands" element={<BrandsPage uid={user.uid} />} />
      <Route path="products/low-stock" element={<LowStockProducts uid={user.uid} />} />
      <Route path="sold-products" element={<SoldProductsPage uid={user.uid} />} />
      <Route path="products/edit/:productId" element={<EditProductPage uid={user.uid} />} />
      <Route path="orders" element={<OrdersPage uid={user.uid} />} />
      <Route path="order/:distributorId/:orderId" element={<OrderDetailPage uid={user.uid} />} />
      <Route path="vendeurs" element={<VendeursPage uid={user.uid} />} />
      <Route path="add-vendeur" element={<AddVendeursPage uid={user.uid} />} />
      <Route path="edit-vendeur/:vendeurId" element={<EditVendeurPage uid={user.uid} />} />
      <Route path="clients" element={<ClientsListPage uid={user.uid} />} />
      <Route path="add-client" element={<AddClientPage uid={user.uid} />} />
      <Route path="edit-client/:clientId" element={<EditClientPage uid={user.uid} />} />
      <Route path="client-orders/:clientId" element={<ClientOrdersPage uid={user.uid} />} />
    </Route>
  </>
)}

      {/* FALLBACK */}
      <Route
        path="*"
        element={
          <div style={{ padding: 30, color: "red" }}>
            Unauthorized user. Please contact admin.
          </div>
        }
      />

    </Routes>
  </HashRouter>
);
}

export default App;
